"use strict";
// <copyright file="loaderTab.tsx" company="Top365">
// Copyright (c) Top365. All rights reserved.
// </copyright>
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_northstar_1 = require("@fluentui/react-northstar");
var _ = require('lodash');
require("../loaders/loader.scss");
require("../loaders/loaderPainel.scss");
var loaderList_1 = require("../loaders/loaderList");
/** Component for displaying loading component. */
var Loader = function () {
    return (React.createElement("div", { className: "main-component" },
        React.createElement("div", { className: "form-container" },
            React.createElement(react_northstar_1.Skeleton, { animation: "pulse" },
                React.createElement(react_northstar_1.Flex, { gap: "gap.large", space: "between" },
                    React.createElement(react_northstar_1.FlexItem, { size: "size.quarter" },
                        React.createElement(react_northstar_1.Segment, { styles: { boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" } },
                            React.createElement(react_northstar_1.Box, { styles: {
                                    display: "grid",
                                    gridGap: ".5rem",
                                    gridTemplate: "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(28.75rem, 1fr))",
                                    gridAutoFlow: "dense",
                                    gridAutoRows: "15rem 2rem",
                                    padding: "1rem",
                                    minWidth: "20rem",
                                    "@media (max-width: 986px)": {
                                        gridTemplate: "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                    },
                                } },
                                React.createElement(react_northstar_1.Card.Header, null,
                                    React.createElement(react_northstar_1.Flex, { gap: "gap.small", space: "between", style: { minHeight: "2rem" } },
                                        React.createElement(react_northstar_1.Flex, { gap: "gap.small", column: true },
                                            React.createElement(react_northstar_1.Skeleton.Line, { width: "150px" })))),
                                React.createElement(react_northstar_1.Card.Body, { style: {
                                        marginBottom: "0.75rem",
                                        height: "100%",
                                        overflow: "hidden",
                                    }, fitted: true },
                                    React.createElement(react_northstar_1.Flex, { gap: "gap.large", styles: {
                                            height: "100%",
                                            display: "flex",
                                        }, column: true },
                                        React.createElement(react_northstar_1.Skeleton.Shape, { width: "100%", height: "100%" }))),
                                React.createElement(react_northstar_1.Card.Footer, { fitted: true },
                                    React.createElement(react_northstar_1.Flex, { gap: "gap.large", hAlign: "end", styles: {
                                            height: "100%",
                                            display: "flex",
                                        } },
                                        React.createElement(react_northstar_1.Skeleton.Shape, { width: "20%", height: "100%" })))))),
                    React.createElement(react_northstar_1.FlexItem, { size: "size.quarter" },
                        React.createElement(react_northstar_1.Segment, { styles: { boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" } },
                            React.createElement(react_northstar_1.Box, { styles: {
                                    display: "grid",
                                    gridGap: ".5rem",
                                    gridTemplate: "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(28.75rem, 1fr))",
                                    gridAutoFlow: "dense",
                                    gridAutoRows: "15rem 2rem",
                                    padding: ".5rem 2rem",
                                    minWidth: "20rem",
                                    "@media (max-width: 986px)": {
                                        gridTemplate: "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                    },
                                } },
                                React.createElement(react_northstar_1.Card.Header, null,
                                    React.createElement(react_northstar_1.Flex, { gap: "gap.small", space: "between", style: { minHeight: "2rem" } },
                                        React.createElement(react_northstar_1.Flex, { gap: "gap.small", column: true },
                                            React.createElement(react_northstar_1.Skeleton.Line, { width: "150px" })))),
                                React.createElement(react_northstar_1.Card.Body, { style: {
                                        marginBottom: "0.75rem",
                                        height: "100%",
                                        overflow: "hidden",
                                    }, fitted: true },
                                    React.createElement(react_northstar_1.Flex, { styles: {
                                            height: "100%",
                                            display: "flex",
                                        }, column: true },
                                        React.createElement(react_northstar_1.Skeleton.Shape, { width: "100%", height: "100%" }))),
                                React.createElement(react_northstar_1.Card.Footer, { fitted: true },
                                    React.createElement(react_northstar_1.Flex, { gap: "gap.large", hAlign: "end", styles: {
                                            height: "100%",
                                            display: "flex",
                                        } },
                                        React.createElement(react_northstar_1.Skeleton.Shape, { width: "20%", height: "100%" })))))),
                    React.createElement(react_northstar_1.FlexItem, { size: "size.half" },
                        React.createElement(react_northstar_1.Segment, { styles: { boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" } },
                            React.createElement(react_northstar_1.Box, { styles: {
                                    display: "grid",
                                    gridGap: ".5rem",
                                    gridTemplate: "repeat(auto-fill, 2rem) / repeat(auto-fill, minmax(43.50rem, 1fr))",
                                    gridAutoFlow: "dense",
                                    gridAutoRows: "15rem 2rem",
                                    padding: ".5rem 2rem",
                                    minWidth: "20rem",
                                    "@media (max-width: 986px)": {
                                        gridTemplate: "repeat(auto-fill, 25rem) / repeat(auto-fill, minmax(15.75rem, 1fr))",
                                    },
                                } },
                                React.createElement(react_northstar_1.Card.Header, null,
                                    React.createElement(react_northstar_1.Flex, { gap: "gap.small", space: "between", style: { minHeight: "2rem" } },
                                        React.createElement(react_northstar_1.Flex, { gap: "gap.small", column: true },
                                            React.createElement(react_northstar_1.Skeleton.Line, { width: "150px" })))),
                                React.createElement(react_northstar_1.Card.Body, { style: {
                                        marginBottom: "0.75rem",
                                        height: "100%",
                                        overflow: "hidden",
                                    }, fitted: true },
                                    React.createElement(react_northstar_1.Flex, { styles: {
                                            height: "100%",
                                            display: "flex",
                                        }, column: true },
                                        React.createElement(react_northstar_1.Skeleton.Shape, { width: "100%", height: "100%" }))),
                                React.createElement(react_northstar_1.Card.Footer, { fitted: true },
                                    React.createElement(react_northstar_1.Flex, { gap: "gap.large", hAlign: "end", styles: {
                                            height: "100%",
                                            display: "flex",
                                        } },
                                        React.createElement(react_northstar_1.Skeleton.Shape, { width: "10%", height: "100%" }))))))),
                React.createElement(react_northstar_1.Flex, { space: "between", styles: {
                        position: "sticky",
                        top: 0,
                        padding: "1.25rem 1.25rem 1.25rem 0",
                        margin: "1.25rem 0",
                        boxShadow: "rgb(0 0 0 / 21%) 0 8px 6px -6px",
                        zIndex: 999,
                    } },
                    React.createElement(react_northstar_1.Flex, { gap: "gap.small", styles: {
                            width: "100%"
                        } },
                        React.createElement(react_northstar_1.FlexItem, { className: "tab-status-item" },
                            React.createElement(react_northstar_1.Skeleton.Input, null)),
                        React.createElement(react_northstar_1.FlexItem, { className: "tab-status-item" },
                            React.createElement(react_northstar_1.Skeleton.Input, null)),
                        React.createElement(react_northstar_1.FlexItem, { className: "tab-status-item" },
                            React.createElement(react_northstar_1.Skeleton.Input, null)),
                        React.createElement(react_northstar_1.FlexItem, { className: "tab-status-item" },
                            React.createElement(react_northstar_1.Skeleton.Input, null)))),
                React.createElement(React.Fragment, null,
                    React.createElement(react_northstar_1.Segment, { styles: { gridColumn: 'span 6', background: 'transparent', paddingTop: '0px', boxShadow: 'none' } },
                        React.createElement(loaderList_1.default, null)))))));
};
exports.default = Loader;
//# sourceMappingURL=loaderPainel.js.map